import { useState } from "react";
import { Link } from "react-router-dom";
import VideoCard from "@/components/base/VideoCard";
import { videos } from "@/mocks/videos";

const sorted = [...videos].sort((a, b) => b.year - a.year || b.rating - a.rating);
const PAGE_SIZE = 8;

export default function LatestGrid() {
  const [visible, setVisible] = useState(PAGE_SIZE);
  const list = sorted.slice(0, visible);
  const hasMore = visible < sorted.length;

  return (
    <section className="mx-auto w-full max-w-[1440px] px-4 py-10 md:px-6 md:py-14 lg:px-10">
      <div className="mb-6 flex items-end justify-between">
        <div>
          <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">最新影视内容</h2>
          <p className="mt-1.5 text-sm text-foreground-600">持续更新的剧集与综艺，随手就能追起来</p>
        </div>
        <Link
          to="/category"
          className="hidden items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-400 transition-colors hover:text-primary-300 sm:flex"
        >
          查看更多
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:gap-4 lg:grid-cols-4 xl:grid-cols-5">
        {list.map((item) => (
          <VideoCard key={item.id} item={item} />
        ))}
      </div>

      {hasMore && (
        <div className="mt-8 flex justify-center">
          <button
            type="button"
            onClick={() => setVisible((prev) => prev + PAGE_SIZE)}
            className="flex items-center gap-2 whitespace-nowrap rounded-full border border-background-300 px-6 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-500 hover:text-primary-400"
          >
            <i className="ri-add-line text-lg"></i>
            加载更多
          </button>
        </div>
      )}
    </section>
  );
}